<template>
  <div>
    <v-card-item
      v-for="otherCharge in otherCharges"
      :key="otherCharge.otherChargeID"
    >
      <template slot="title">
        {{ otherCharge.note }}
      </template>
      <template slot="actions">
        <IconButton
          icon="fa-times-circle"
          tooltip="Delete Reservation"
          color="red"
          @click="deleteCartOtherCharge({otherChargeID: otherCharge.otherChargeID})"
        />
      </template>
      <template>
        <v-layout row>
          <v-flex xs8>
            <strong> Stream: </strong>{{ otherCharge.accountEntryTypeID }}
          </v-flex>
          <v-flex>
            <strong>Price:</strong> ${{ otherCharge.price }}
          </v-flex>
        </v-layout>
      </template>
    </v-card-item>
  </div>
</template>

<script>
// user/vehicles?

import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      otherCharges: 'cart/otherCharges'
    })
  },
  methods: {
    ...mapActions({
      deleteCartOtherCharge: 'cart/deleteOtherCharge'
    })
  }
}
</script>
